import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
import Url from "../../apiCall/UrlConfig";
import { Button, Divider, Table, message } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const PrecentationTreshhold = 20;
const ExamReportForStudent = (props) => {
  const navigation = useNavigate();
  const ColumnListExam = [
    { title: "کد", dataIndex: "id", key: "id" },
    {
      title: "تصویر",
      dataIndex: "name",
      key: "name",
      render: (_, item, index) => {
        return (
          <div>
            <img src={ImagePreAddress + item.imageUrl} width={50} />
          </div>
        );
      },
    },
    {
      title: "تحلیل آزمون",
      dataIndex: "studentCode",
      key: "studentCode",
      render: (_, item) => {
        return _renderAnalyses(item);
      },
    },
  ];

  const _renderAnalyses = (item) => {
    let NumberGoldStandard = item?.refrenceImageDetails?.length;
    let NumberStudentDignos = item?.studentImageDetails?.length;
    let NumberCorectStudent = item?.reportExamList.filter(
      (o) => o.precentMatching > PrecentationTreshhold
    ).length;

    let NumberNotDignose = item?.reportExamList.filter(
      (o) => o.examImageDetailId == -1
    ).length;

    let NumberDignoseIncorect = item?.reportExamList.filter(
      (o) =>
        o.examImageDetailId > -1 && o.precentMatching < PrecentationTreshhold
    ).length;

    return (
      <div>
        <div>تعداد تشخیص استاد = {NumberGoldStandard}</div>
        <div>تعداد تشخیص دانشجو = {NumberStudentDignos}</div>
        <div>تعداد تشخیص صحیح دانشجو = {NumberCorectStudent}</div>
        <div>تعداد عدم تشخیص دانشجو = {NumberNotDignose}</div>
        <div>تعداد تشخیص غلط دانشجو = {NumberDignoseIncorect}</div>
      </div>
    );
  };
  useEffect(() => {
    _onGetDetail();
  }, []);

  const _onGetDetail = async () => {
    let url = Url.GetImageDetailOfStudent;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});
    debugger;
    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _ReturnExpandRow = (record) => {
    let _HbeW = record?.imageHeight / record?.imageWidth;
    let _imageSize = window.innerWidth / 2 - 50;
    return (
      <div dir="ltr" className="expandRowForDetailExam">
        <div>
          <Divider>تشخیص دانشجو</Divider>

          {record?.studentImageDetails.map((o) => {
            let Report = record?.reportExamList.find(
              (t) => t.numberTooth == o.numberTooth && t.type == o.typeDetail
            );

            return (
              <div>
                <div className="text-center">
                  {o.numberTooth} {"==>"} {o.typeDetail}
                </div>
                <div
                  className="text-center"
                  style={{
                    color: Report?.precentMatching > 20 ? "green" : "red",
                  }}
                >
                  {" "}
                  تطابق {Report?.precentMatching} درصد
                </div>
                <img
                  src={o.base64Masked}
                  style={{
                    backgroundImage:
                      "url(" + ImagePreAddress + record.imageUrl + ")",
                    backgroundSize: "cover",
                  }}
                  width={_imageSize}
                  height={_HbeW * _imageSize}
                />
                <Divider />
              </div>
            );
          })}
          {/* <Table dataSource={record?.studentImageDetails}></Table> */}
        </div>
        <div>
          <Divider>تشخیص استاد</Divider>
          {record?.refrenceImageDetails.map((o) => {
            let Report = record?.reportExamList.find(
              (t) => t.numberTooth == o.numberTooth && t.type == o.typeDetail
            );

            return (
              <div>
                <div className="text-center">
                  {o.numberTooth} {"==>"}
                  {o.typeDetail}
                </div>
                <div
                  className="text-center"
                  style={{
                    color: Report?.precentMatching > 20 ? "green" : "red",
                  }}
                >
                  تطابق {Report?.precentMatching} درصد
                </div>
                <img
                  src={o.base64Masked}
                  style={{
                    backgroundImage:
                      "url(" + ImagePreAddress + record.imageUrl + ")",
                    backgroundSize: "cover",
                  }}
                  width={_imageSize}
                  height={_HbeW * _imageSize}
                />
                <Divider />
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  return (
    <div>
      <Divider>برای مشاهده جزییات بر روی + کلیک نمایید</Divider>
      <div className="margin-horizontal">
        به دلیل در دسترس نبودن چند انتخابی در قسمت اپلاینس ارتودنسی در آزمون
        بررسی ها این قسمت از ازمون در نظر گرفته نشد ولی در ازمون نهایی بررسی
        اصلی حتما لحاظ خواهد شد{" "}
      </div>
      <div style={{ alignSelf: "center", width: "100%" }}>
        <Table
          columns={ColumnListExam}
          dataSource={
            props.coreData[Url.GetImageDetailOfStudent]?.[Url.action]?.data
              ?.listImage
          }
          loading={
            props.coreData[Url.GetImageDetailOfStudent]?.[Url.action]
              ?.isFetching
          }
          expandable={{
            expandedRowRender: (record) => {
              return _ReturnExpandRow(record);
            },
          }}
          rowKey={(o) => o.id}
        />
        <Button onClick={() => navigation("/dentistLabeling")}>بازگشت</Button>
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExamReportForStudent);
